import React, { useEffect, useRef } from 'react';
import { object } from 'prop-types';
import StockIcon from 'Component/StockIcon';
import { CloseIcon } from 'Component/SvgIcon/icons';
import useStockTicker from '@context/stockTickerTab/useStockTickerTab';
import stockService from '@services/stock';
import { styStockTickerItem } from '../style';
import Changes from './Changes';

/**
 * @param {object} Params
 * @param {object} Params.item
 * @param {string} Params.item.code
 * @param {boolean} Params.item.isActive
 */
function Tab({ item }) {
  const { isActive, code } = item;
  /** @type {import('react').MutableRefObject<HTMLElement>} */
  const refEl = useRef();
  const { closeCode, openCode } = useStockTicker();
  const { data, isSuccess } = stockService.detail.about.useAbout(item.code);

  // Close tab if code is invalid
  if (isSuccess && data.code !== code) {
    closeCode(code);
  }

  const handleChangeTab = () => openCode(code);
  const handleClose = (e) => {
    closeCode(item.code);
    e.stopPropagation();
  };

  useEffect(() => {
    if (!isActive || !refEl?.current) {
      return;
    }

    setTimeout(() => {
      // Disable it until approved, because the experience is not smooth enough
      refEl?.current?.scrollIntoView({ behavior: 'smooth' });
    }, 1000);
  }, [isActive]);

  return (
    <div
      ref={refEl}
      type="button"
      data-key={item.code}
      className={styStockTickerItem({ isActive })}
      onClick={handleChangeTab}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          handleChangeTab();
        }
      }}
      tabIndex="0"
    >
      <div className="___content">
        <StockIcon code={item.code} />
        <span className="___code">{code}</span>
        <span className="___changes">
          <Changes code={code} />
        </span>
      </div>
      <button className="___close" type="button" onClick={handleClose}>
        <CloseIcon />
      </button>
    </div>
  );
}

Tab.propTypes = {
  item: object.isRequired,
};

export default Tab;
